var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logintop{background-image:url(" + escape(require("../../assets/img/login.jpg")) + ");background-size:cover;color:#fff;height:10vh}.logo img{height:5vh}.main-register{height:80vh}", ""]);

// exports
